import { render, staticRenderFns } from "./PlantDetail.vue?vue&type=template&id=eb2c417a&scoped=true&"
import script from "./PlantDetail.vue?vue&type=script&lang=ts&"
export * from "./PlantDetail.vue?vue&type=script&lang=ts&"
import style0 from "./PlantDetail.vue?vue&type=style&index=0&id=eb2c417a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb2c417a",
  null
  
)

export default component.exports